module.exports = __webpack_public_path__ + "img/heart-lighter.7ba77611.svg";